import { createFileRoute } from '@tanstack/react-router'
import { TermsPage } from '~/components/marketing/terms-page'
import { marketingPageHead } from '~/lib/site-meta'

const TITLE = 'Termos de Uso | Planno'
const DESCRIPTION =
  'Termos de Uso da plataforma Planno: cadastro, uso aceitável, propriedade intelectual, pagamentos, LGPD e disposições gerais.'

export const Route = createFileRoute('/termos-de-uso')({
  component: TermsPage,
  head: () =>
    marketingPageHead({
      description: DESCRIPTION,
      locale: 'pt-BR',
      path: '/termos-de-uso',
      title: TITLE,
    }),
})
